import immutable from 'immutability-helper';
import { handleActions } from 'redux-actions';
import { cache } from '../relay';

import { ActionTypes } from '../constants';

export const userState = {
  logged: false,
  verifiedToken: false,
  newUserRegistered: false,
  token: null,
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  status: 'idle',
};

export default {
  user: handleActions(
    {
      [ActionTypes.USER_LOGIN_REQUEST](state) {
        return immutable(state, {
          status: { $set: 'running' },
          token: { $set: null },
          error: { $set: null },
        });
      },
      [ActionTypes.USER_LOGIN_SUCCESS](state, { payload: { token, timezone } }) {
        return immutable(state, {
          logged: { $set: true },
          verifiedToken: { $set: true },
          token: { $set: token },
          timezone: { $set: timezone },
          status: { $set: 'idle' },
        });
      },
      [ActionTypes.USER_LOGIN_FAILURE](state, { payload }) {
        return immutable(state, {
          logged: { $set: false },
          verifiedToken: { $set: false },
          token: { $set: null },
          error: { $set: payload },
          status: { $set: 'idle' },
        });
      },
      //
      [ActionTypes.USER_GOOGLE_LOGIN_REQUEST](state) {
        return immutable(state, {
          status: { $set: 'running' },
          token: { $set: null },
          error: { $set: null },
        });
      },
      [ActionTypes.USER_GOOGLE_LOGIN_SUCCESS](state, { payload: { token, newUserRegistered } }) {
        return immutable(state, {
          logged: { $set: true },
          verifiedToken: { $set: true },
          token: { $set: token },
          newUserRegistered: { $set: newUserRegistered },

          status: { $set: 'idle' },
        });
      },
      [ActionTypes.USER_GOOGLE_LOGIN_FAILURE](state, { payload }) {
        return immutable(state, {
          logged: { $set: false },
          verifiedToken: { $set: false },
          token: { $set: null },
          error: { $set: payload },
          status: { $set: 'idle' },
        });
      },

      [ActionTypes.USER_UNVERIFY_TOKEN_REQUEST](state, { payload: { token } }) {
        return immutable(state, {
          status: { $set: 'running' },
          token: { $set: token || state.token },
        });
      },
      [ActionTypes.USER_UNVERIFY_TOKEN_SUCCESS](state) {
        return immutable(state, {
          verifiedToken: { $set: false },
          status: { $set: 'idle' },
        });
      },
      [ActionTypes.USER_UNVERIFY_TOKEN_FAILURE](state, { payload }) {
        return immutable(state, {
          error: { $set: payload },
          status: { $set: 'idle' },
        });
      },
      [ActionTypes.UPDATE_INTERFACE_USER_TIMEZONE]: (state, { payload }) => {
        const { userTimezone } = payload;
        return immutable(state, {
          timezone: { $set: userTimezone },
        });
      },
      [ActionTypes.USER_VERIFY_TOKEN_REQUEST](state) {
        return immutable(state, {
          status: { $set: 'running' },
        });
      },
      [ActionTypes.USER_VERIFY_TOKEN_SUCCESS](state, { payload }) {
        return immutable(state, {
          logged: { $set: true },
          verifiedToken: { $set: true },
          token: { $set: payload },
          status: { $set: 'idle' },
        });
      },
      [ActionTypes.USER_VERIFY_TOKEN_FAILURE](state, { payload }) {
        return immutable(state, {
          logged: { $set: false },
          verifiedToken: { $set: false },
          token: { $set: null },
          error: { $set: payload },
          status: { $set: 'idle' },
        });
      },

      [ActionTypes.USER_LOGOUT_REQUEST](state) {
        return immutable(state, {
          status: { $set: 'running' },
        });
      },
      [ActionTypes.USER_LOGOUT_SUCCESS](state) {
        cache.clear();

        return immutable(state, {
          logged: { $set: false },
          verifiedToken: { $set: false },
          token: { $set: null },
          status: { $set: 'idle' },
        });
      },
    },
    userState,
  ),
};
//
// import { REHYDRATE } from 'redux-persist'
// import { createReducer } from '../utils/helpers';
//
// import { ActionTypes } from '../constants/index';
//
// export const userState = {
//   logged: false,
//   rehydrated: false
// };
//
// export default {
//   user: createReducer(userState, {
//     [REHYDRATE](state, action) {
//       if (action.payload.user) {
//         return Object.assign({}, state, action.payload.user, {
//           rehydrated: true
//         });
//       }
//
//       return { ...state };
//     },
//     [ActionTypes.USER_VERIFY_TOKEN_REQUEST](state, action) {
//       return { ...state };
//     },
//     [ActionTypes.REDIRECT_LOGGED_USER](state, action) {
//       return { ...state };
//     },
//     [ActionTypes.USER_LOGIN_SUCCESS](state, action) {
//       return { ...state, logged: true, token: action.payload };
//     },
//     [ActionTypes.USER_LOGIN_FAILURE](state, action) {
//       return { ...state, logged: false, token: null };
//     },
//     [ActionTypes.USER_LOGOUT_SUCCESS](state) {
//       return { ...state, logged: false, token: null };
//     }
//   })
// };
